<script>
import { UserService } from '@/service/backend/user.service';
export default {
    mounted() {
        UserService.logout()
    }
}
</script>
